import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, {
        width: "62",
        height: "62",
        viewBox: "0 0 62 62",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                filter: "url(#filter0_d_7_7269)",
                children: [
                    /*#__PURE__*/ _jsx("rect", {
                        x: "11",
                        y: "6",
                        width: "40",
                        height: "40",
                        rx: "12",
                        fill: "#194BFB",
                        shapeRendering: "crispEdges"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M40.7118 23.2949L36.711 19.2941C36.6178 19.2009 36.5071 19.1269 36.3852 19.0764C36.2634 19.026 36.1328 19 36.0009 19C35.7346 19 35.4791 19.1058 35.2908 19.2941C35.1024 19.4825 34.9966 19.7379 34.9966 20.0043C34.9966 20.2706 35.1024 20.5261 35.2908 20.7144L37.5912 23.0048L25.9991 23.0048C25.7338 23.0048 25.4794 23.1102 25.2919 23.2978C25.1043 23.4853 24.9989 23.7397 24.9989 24.005C24.9989 24.2703 25.1043 24.5247 25.2919 24.7122C25.4794 24.8998 25.7338 25.0052 25.9991 25.0052L40.0016 25.0052C40.1991 25.0042 40.3918 24.9448 40.5556 24.8344C40.7193 24.7241 40.8468 24.5677 40.9218 24.3851C40.9984 24.2029 41.0193 24.0022 40.9819 23.8082C40.9446 23.6141 40.8505 23.4355 40.7118 23.2949V23.2949ZM36.0009 27.0055H21.9984C21.8009 27.0065 21.6082 27.0659 21.4444 27.1763C21.2807 27.2866 21.1532 27.443 21.0782 27.6257C21.0016 27.8078 20.9807 28.0085 21.0181 28.2026C21.0554 28.3966 21.1495 28.5752 21.2882 28.7159L25.289 32.7166C25.3819 32.8103 25.4926 32.8847 25.6144 32.9355C25.7363 32.9863 25.8671 33.0124 25.9991 33.0124C26.1311 33.0124 26.2619 32.9863 26.3837 32.9355C26.5056 32.8847 26.6162 32.8103 26.7092 32.7166C26.803 32.6236 26.8774 32.513 26.9282 32.3911C26.9789 32.2692 27.0051 32.1385 27.0051 32.0065C27.0051 31.8744 26.9789 31.7437 26.9282 31.6218C26.8774 31.4999 26.803 31.3893 26.7092 31.2963L24.4088 29.0059H36.0009C36.2662 29.0059 36.5206 28.9005 36.7081 28.713C36.8957 28.5254 37.0011 28.271 37.0011 28.0057C37.0011 27.7405 36.8957 27.4861 36.7081 27.2985C36.5206 27.1109 36.2662 27.0055 36.0009 27.0055Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsxs("filter", {
                    id: "filter0_d_7_7269",
                    x: "0",
                    y: "0",
                    width: "62",
                    height: "62",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ _jsx("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ _jsx("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ _jsx("feOffset", {
                            dy: "5"
                        }),
                        /*#__PURE__*/ _jsx("feGaussianBlur", {
                            stdDeviation: "5.5"
                        }),
                        /*#__PURE__*/ _jsx("feComposite", {
                            in2: "hardAlpha",
                            operator: "out"
                        }),
                        /*#__PURE__*/ _jsx("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0.0980392 0 0 0 0 0.294118 0 0 0 0 0.984314 0 0 0 0.25 0"
                        }),
                        /*#__PURE__*/ _jsx("feBlend", {
                            mode: "normal",
                            in2: "BackgroundImageFix",
                            result: "effect1_dropShadow_7_7269"
                        }),
                        /*#__PURE__*/ _jsx("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "effect1_dropShadow_7_7269",
                            result: "shape"
                        })
                    ]
                })
            })
        ]
    });
};
export default Icon;
